import React from 'react';
import { Field } from 'react-final-form';

import { AdCampaignFormValues, AdsFreeTrialConfig } from 'modules/campaigns/types';

import { FreeTrialFormContentDisabled } from './components/FreeTrialFormContentDisabled';
import { FreeTrialFormContentEnabled } from './components/FreeTrialFormContentEnabled';
import { ExistingFreeTrialPlaceholder } from '../ExistingFreeTrialPlaceholder';

type FreeTrialFormItemProps = {
  isExistingFreeTrial: boolean;
  adsFreeTrialConfig: AdsFreeTrialConfig | undefined;
};

export const FreeTrialFormItem = ({ isExistingFreeTrial, adsFreeTrialConfig }: FreeTrialFormItemProps) => {
  if (isExistingFreeTrial) {
    return <ExistingFreeTrialPlaceholder />;
  }

  if (!adsFreeTrialConfig) {
    return null;
  }

  return (
    <Field<AdCampaignFormValues['isFreeTrial']> name="isFreeTrial">
      {({ input }) => {
        if (input.value === true) {
          return (
            <FreeTrialFormContentEnabled
              freeTrialToggleChangeHandler={input.onChange}
              adsFreeTrialConfig={adsFreeTrialConfig}
            />
          );
        }

        return <FreeTrialFormContentDisabled freeTrialToggleChangeHandler={input.onChange} />;
      }}
    </Field>
  );
};
